import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MikIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99569)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM2.293 21.83H3.797V15.52L5.383 21.83H6.94L8.532 15.52V21.83H10.036V13.813H7.609L6.17 19.283L4.716 13.813H2.293V21.83ZM11.595 21.83H13.215V13.813H11.595V21.83ZM14.778 21.83H16.397V19.408L17.709 18.068L19.913 21.831H22.008L18.825 16.936L21.844 13.813H19.667L16.397 17.373V13.813H14.778V21.83ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99569'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

MikIcon.displayName = 'MikIcon'
